<template>
  <el-container>
    <el-header>
      <el-row>
        <el-col :span="22">
          <h5 class="title">{{$route.params.id != null?"编辑常用语":"添加常用语"}}</h5>
        </el-col>
        <el-col :span="2">
          <el-button class="back" @click="back" size="small" type="danger" icon="el-icon-back" plain>返回</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-form
        :model="form"
        status-icon
        :rules="rules"
        ref="form"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="常用语类型:">
          <el-input value="个人常用语" disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="常用语:" prop="expression">
          <el-input v-model="form.expression"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="submitForm('form')">保存</el-button>
          <el-button @click="back" size="small" plain>取消</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "approvalItemEdit",
  props: ["id"],
  data() {
    return {
      rules: {
        expression:[
          { required: true, message: '请输入常用语', trigger: 'blur' }
        ]
      }
    };
  },
  computed: mapState({
    form: state => state.approvalItem.form
  }),
  methods: {
    back() {
      this.$router.go(-1); //返回上一层
    },
    submitForm(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.form.type = 4;
          this.$store
            .dispatch("approvalItem/approvalItemSave", this.form)
            .then(res => {
              this.$router.go(-1);
            });
        } else {
          return false;
        }
      });
    }
  },
  created() {
    this.$store.dispatch("approvalItem/detail", this.id);
  }
};
</script>

<style lang="stylus" scoped>
.el-container {
  background-color: #fff;
}

.el-header {
  padding-top: 10px;
  border-bottom: 1px solid #E7EAEC;
}

.el-select {
  height: 32px;
}

.title {
  font-size: 16px;
  margin: 0;
  margin-top: 10px;
}
.back{
    float :right;
    margin-top:4px;
}
</style>

